<template>
  <div>
    <querytitle>
            <template slot="queryleft">
              <div>任务类型:</div>
                <div>
                    <el-select v-model="querys.spetype" size="mini" style="width:150px;" @change="getlist()">
                        <el-option v-for="(item) in types" :key="item.dict_name" :label="item.dict_name"
                            :value="item.dict_name">
                        </el-option>
                    </el-select>
                </div>
                <div>日期：</div>
                <div>
                    <el-date-picker v-model="querys.bdate" type="date" placeholder="选择开始日期" size="mini"
                        style="width:150px;">
                    </el-date-picker>
                </div>
                <div>至</div>
                <div>
                    <el-date-picker v-model="querys.edate" type="date" placeholder="选择结束日期" size="mini"
                        style="width:150px;">
                    </el-date-picker>
                </div>
                <div>模糊查找：</div>
                <div>
                    <el-input v-model="querys.keywords" size="mini" placeholder="多个关键词用逗号隔开" style="width:200px;"></el-input>
                </div>
                <div><el-button type="primary" size="mini" @click="getlist()">查找</el-button></div>
            </template>
        </querytitle>
        <el-table :data="itemlist" border style="width:100%" :height="hh" stripe size="mini">
            <el-table-column prop="spe_type" label="任务类型" width="180"></el-table-column>
            <el-table-column prop="spe_name" label="任务名称" width="260"></el-table-column>
            <el-table-column prop="spe_date" label="制定日期" width="100"></el-table-column>
            <el-table-column prop="spe_desc" label="任务描述"></el-table-column>
            <el-table-column prop="file_count_push" label="报送数量" width="80" align="center"></el-table-column>
            <el-table-column prop="file_count_takein" label="选定数量" width="80" align="center"></el-table-column>
            <el-table-column fixed="right" label="操作" width="170">
              <template slot-scope="scope">
                    <div>
                      <el-button @click="change(scope)" type="success" size="mini">查看</el-button>
                      <el-link :href="'/api/speshow?speid='+scope.row.spe_id" target="_blank" icon="el-icon-share" type="primary">任务汇总</el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :title="itemedit.spe_name" width="90%" :visible.sync="dialogFormVisible" top="6vh">
            <querytitle>
                <template slot="queryleft">
                    分配单位：<el-tag size="mini" type="warning">{{ takeinsum.unit_count ==0 ?'全部': takeinsum.unit_count+'个'}}</el-tag>
                    报送单位：<el-tag size="mini" type="warning">{{ takeinsum.unit_count_push }}个</el-tag>
                    报送图片：<el-tag size="mini" type="warning">{{ takeinsum.file_count_push }}份</el-tag>
                    采纳单位：<el-tag size="mini" type="warning">{{ takeinsum.unit_count_takein }}个</el-tag>
                    采纳图片：<el-tag size="mini" type="warning">{{ takeinsum.file_count_takein }}份</el-tag>
                </template>
                <template slot="queryright">
                    <el-button type="success" icon="el-icon-download" size="small" @click="downzipfile(itemedit.spe_id,itemedit.spe_name)">打包下载</el-button>
                </template>
            </querytitle>
            <div class="pagelist" :style="{ height: hh2 + 'px' }">
            <div class="listitem" v-for="(item) in takeinlist" :key="item.new_id">
                    <div>
                        <el-image :src="getfirstitem(item.file_surls_takein,',')"  :preview-src-list="getitems(item.file_urls_takein,',')" style="width:130px;height:130px;"></el-image>
                        <div style="text-align: center;">
                            {{item.unit_name}}<br />
                            {{item.new_title}}
                        </div>
                    </div>
                    <div class="countitem">
                        <span class="countitem1" title="目前选取的图片数量">{{ item.file_count_takein}}</span>
                        <!-- <span class="countitem2" title="本材料所有的图片数量">{{ item.file_count}}</span> -->
                    </div>
            </div>
        </div>
        </el-dialog>
  </div>
</template>

<script>
import querytitle from '@/components/querytitle'
export default {
    components: {
        querytitle
    },
    data(){
        return {
            hh: 500,
            hh2: 350,
            loading: false,
            itemlist: [],
            itemindex: 0,
            itemedit: {},
            dialogFormVisible: false,
            querys: { spetype: '', state: '确认', bdate: '', edate: '', keywords: '' ,querymode:'0',showcount:100},
            types: [], 
            typesbyall:[],
            states: ['草稿','确认'],
            takeinlist:[],
            takeinsum:{}
        }
    },
    created(){
        this.hh = document.documentElement.clientHeight - 200;
        this.hh2 = this.hh - 20;
        let that = this
        that.querys.bdate = that.CU.cu.yy + '-01-01';
        that.querys.edate = that.FormatDate(new Date());
        // that.GetDict('任务类型', function (res) {
        //     that.types = res.data
        //     if (res.data.length > 0)
        //         that.querys.spetype = res.data[0].dict_name
        //     that.getlist();
        // })
        that.GetDict('任务类型', function (res) {
            that.typesbyall = res.data;
            that.types.push({dict_id:'全部',dict_name:"全部"});
            that.typesbyall.forEach((item)=>{
                that.types.push(item);
            })
            that.querys.spetype = "全部"
            that.getlist();
        })
        // that.GETENUM('spe_main', 'spe_state', true, function (res) {
        //     that.states = res
        // })
        
    },
    methods:{
        getfirstitem(strlist,str){//获取字符串中的第一项
            var n = strlist.split(str);
            if(n.length>0)
                return n[0];
            else
                return "";
        },
        getitems(strlist,str){
            let n = strlist.split(str);
            return n;
        },
        getlist() {
            let that = this
            that.querys.bdate = that.FormatDate(that.querys.bdate)
            that.querys.edate = that.FormatDate(that.querys.edate)
            that.PostData("Spe/SpeQuery", that.querys, function (res) {
                that.itemlist = res.data.data;
            }, function (err) {
                that.$alert(err, { title: "错误" });
            });
        },
        change(par) {
            let that = this
            this.addflag = false;
            this.itemindex = par.$index;
            this.itemedit = par.row//Object.assign({}, par.row);
            that.GetData('Spe/SpeTakeInList',{speid:that.itemedit.spe_id},function(res){
                that.takeinlist = res.data.data;
            },function(err){
                that.takeinlist = [];
                that.$alert(err, { title: "错误" });
            })
            that.GetData('Spe/SpeSum',{speid:that.itemedit.spe_id},function(res){
                that.takeinsum = res.data.data;
                that.dialogFormVisible = true;
            },function(err){
                that.$alert(err, { title: "错误" });
            })            
        },
        downzipfile(spe_id,spe_name) {
            let that = this
            if(that.takeinsum.file_count_takein<1){
                that.$alert('当前专题任务暂时无材料！', {title: "错误"});
                return
            }
            that.GetData('RepSpeImgsZip',{speid:spe_id,spename:spe_name},function(res){
                window.open(res.data.fileurl);
            },function(err){
            console.log(err)
                that.$message({
                message: err,
                type: 'warning'
                })
            })
        },
    }
}
</script>


<style scoped lang="less">
.pagelist {
    width: 100%;
    height: 380px;
    font-size: 13px;
    border: 1px solid #EBEEF5;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;

    .listitem {
        cursor: pointer;
        width: 150px;
        height: 250px;
        margin: 5px;
        border: 1px solid #EBEEF5;
        border-radius: 3px;
        box-shadow: 5px 5px 2px #EBEEF5;
        position: relative;
        text-align: center;
        .deleteitem {
            position: absolute;
            top: 0px;
            right: 0px;

        }
        .countitem {
            position: absolute;
            top: 0px;
            left: 0px;            
            display: inline-block;
            text-align: center;
            white-space: nowrap;
            
            .countitem1{
                background-color: #F56C6C;
                color: #FFF;
                height: 18px;
                line-height: 18px;
                padding: 0 6px;
                font-size: 12px;
                border: 1px solid #FFF;
            }
            .countitem2 {
                //left: 20px;
                background-color: #b1afaf;
                color: #FFF;  
                height: 18px;
                line-height: 18px;
                padding: 0 6px;
                font-size: 12px;
                border: 1px solid #FFF;          
            }
        }

    }
}</style>
    